<div class="custom-snackbar-container">
  @if (data.icon) {
    <jf-icon [name]="data.icon"
             [size]="data.iconSize || 24"
             [strokeWidth]="data.iconStrokeWidth || 1">
    </jf-icon>
  }
  <span class="snackbar-message">{{ data.message }}</span>
</div>
